export default {
  title: 'Crea chiave API',
  reveal_warning: 'Salva questa chiave ora: non verrà più mostrata.',
  form: {
    name: 'Nome',
    name_placeholder: 'es. Chiave di produzione',
  },
  buttons: {
    cancel: 'Annulla',
    create: 'Crea',
    done: 'Fatto',
  },
  toasts: {
    error: 'Impossibile creare la chiave. Riprova.',
  },
};
